import React, { useState, useEffect } from "react";
import "./MandatoryDisclosure.css";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import SchoolInnerPageBanner from "../../components/SchoolInnerPageBanner";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const MandatoryDisclosure = () => {

  const { school_slug } = useParams();
  const location = useLocation();

  const tableStyle = {
    backgroundColor: 'white',
    // border: '2px solid rgb(100, 19, 32)',
    borderCollapse: "collapse",
    width: "100%",
    maxWidth: "1000px",
    minWidth: '600px',
    color: '#333',
    borderRadius: '10px',
    overflow: 'hidden',

    margin: "0px auto",
  };
  const thStyle = {
    padding: "15px",
    border: "1px solid #ddd",
    color: "rgb(100, 19, 32)",
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '1rem',
    fontFamily: 'Lora',
  };
  const tdStyle = {
    padding: '12px 15px',
    border: "1px solid #ddd",
    textAlign: "center",
    fontSize: '0.9rem',
  };

  const [loading, setLoading] = useState(true);

  const defaultSections = {
    general_information: [{ information: "", details: "" }],
    documents_information: [{ information: "", details: "" }],
    result_academics: [{ information: "", details: "" }],
    staff_information: [{ information: "", details: "" }],
    infrastructure_information: [{ information: "", details: "" }]
  };

  const [sections, setSections] = useState(defaultSections);

  /* ---------------- FETCH DATA ---------------- */

  const fetchSection = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${baseAPIUrl}api/academic/get_mandatory_disclosure/${school_slug}`,
        { withCredentials: true }
      );

      if (res.data.status === 1 && res.data.data) {
        setSections({
          ...defaultSections,
          ...res.data.data
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSection();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  useEffect(() => {
    scrollToTop();
  }, []);

  const isValidUrl = (value) => {
    if (!value) return false;
    return /^(https?:\/\/|www\.)/i.test(value);
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  if (loading) return <p>Loading...</p>;

  return (
    <>
      {/* Hero Section */}
      <SchoolInnerPageBanner />

      <section id="general-information" style={{ padding: '80px 20px', background: 'rgb(100, 19, 32)', color: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* A) GENERAL INFORMATION */}
          <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}> GENERAL INFORMATION</h2>
          <div className="table-responsive">
            <table style={tableStyle}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={thStyle}>SL NO.</th>
                  <th style={thStyle}>INFORMATION</th>
                  <th style={thStyle}>DETAILS</th>
                </tr>
              </thead>
              <tbody>
                {sections.general_information.map((row, index) => (
                  <tr key={index + 1}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={tdStyle}>{row.information}</td>
                    <td style={tdStyle}>
                      {row.details && row.details !== "#" && row.details !== "" ? (
                        isValidUrl(row.details) ? (
                          <a
                            href={row.details.startsWith("http") ? row.details : `https://${row.details}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="click-link"
                          >
                            Click here
                          </a>
                        ) : (
                          <span>{row.details}</span>
                        )
                      ) : (
                        "NA"
                      )}
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section id="documents-information" style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* B) DOCUMENTS AND INFORMATION */}
          <h2 style={{ fontSize: '2.5rem', fontWeight: '700', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora', color: 'rgb(100, 19, 32)' }}> DOCUMENTS AND INFORMATION</h2>
          <div className="table-responsive">
            <table style={tableStyle}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={thStyle}>SL NO.</th>
                  <th style={thStyle}>DOCUMENTS OR INFORMATION</th>
                  <th style={thStyle}>UPLOADED DOCUMENTS</th>
                </tr>
              </thead>
              <tbody>
                {sections.documents_information.map((row, index) => (
                  <tr key={index + 1}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={tdStyle}>{row.information}</td>
                    <td style={tdStyle}>
                      {row.details && row.details !== "#" && row.details !== "" ? (
                        isValidUrl(row.details) ? (
                          <a
                            href={row.details.startsWith("http") ? row.details : `https://${row.details}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="click-link"
                          >
                            Click here
                          </a>
                        ) : (
                          <span>{row.details}</span>
                        )
                      ) : (
                        "NA"
                      )}
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section id="result-academics" style={{ padding: '80px 20px', background: 'rgb(100, 19, 32)', color: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/*  C) RESULT AND ACADEMICS  */}
          <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}> RESULT AND ACADEMICS</h2>
          <div className="table-responsive" >
            <table style={tableStyle}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={thStyle}>SL NO.</th>
                  <th style={thStyle}>DOCUMENTS OR INFORMATION</th>
                  <th style={thStyle}>UPLOADED DOCUMENTS</th>
                </tr>
              </thead>
              <tbody>
                {sections.result_academics.map((row, index) => (
                  <tr key={index + 1}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={tdStyle}>{row.information}</td>
                    <td style={tdStyle}>
                      {row.details && row.details !== "#" && row.details !== "" ? (
                        isValidUrl(row.details) ? (
                          <a
                            href={row.details.startsWith("http") ? row.details : `https://${row.details}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="click-link"
                          >
                            Click here
                          </a>
                        ) : (
                          <span>{row.details}</span>
                        )
                      ) : (
                        "NA"
                      )}
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section id="result-class-x" style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}>RESULT OF CLASS X</h2>
          <div className="table-responsive" >
            <table style={tableStyle}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={thStyle}>SL NO.</th>
                  <th style={thStyle}>YEAR</th>
                  <th style={thStyle}>NO. OF REGISTERED STUDENTS</th>
                  <th style={thStyle}>NO. OF STUDENTSPASSED</th>
                  <th style={thStyle}>PASS PERCENTAGE</th>
                  <th style={thStyle}>REMARK</th>
                </tr>
              </thead>
              <tbody>
                {sections.result_class_x.map((row, index) => (
                  <tr key={index + 1}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={tdStyle}>{row.year}</td>
                    <td style={tdStyle}>{row.registered}</td>
                    <td style={tdStyle}>{row.passed}</td>
                    <td style={tdStyle}>{row.percentage}</td>
                    <td style={tdStyle}>{row.remark}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section id="result-class-xii" style={{ padding: '80px 20px', background: 'rgb(100, 19, 32)', color: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/*  C) RESULT OF CLASS XII  */}
          <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}>RESULT OF CLASS XII</h2>
          <div className="table-responsive" >
            <table style={tableStyle}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={thStyle}>SL NO.</th>
                  <th style={thStyle}>YEAR</th>
                  <th style={thStyle}>NO. OF REGISTERED STUDENTS</th>
                  <th style={thStyle}>NO. OF STUDENTSPASSED</th>
                  <th style={thStyle}>PASS PERCENTAGE</th>
                  <th style={thStyle}>REMARK</th>
                </tr>
              </thead>
              <tbody>
                {sections.result_class_xii.map((row, index) => (
                  <tr key={index + 1}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={tdStyle}>{row.year}</td>
                    <td style={tdStyle}>{row.registered}</td>
                    <td style={tdStyle}>{row.passed}</td>
                    <td style={tdStyle}>{row.percentage}</td>
                    <td style={tdStyle}>{row.remark}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section id="staff-information" style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* D) STAFF INFORMATION */}
          <h2 style={{ fontSize: '2.5rem', fontWeight: '700', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora', color: 'rgb(100, 19, 32)' }}> STAFF (TEACHING & NON-TEACHING) INFORMATION</h2>
          <div className="table-responsive">
            <table style={tableStyle}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={thStyle}>SL NO.</th>
                  <th style={thStyle}>INFORMATION</th>
                  <th style={thStyle}>DETAILS</th>
                </tr>
              </thead>
              <tbody>
                {sections.staff_information.map((row, index) => (
                  <tr key={index + 1}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={tdStyle}>{row.information}</td>
                    <td style={tdStyle}>
                      {row.details && row.details !== "#" && row.details !== "" ? (
                        isValidUrl(row.details) ? (
                          <a
                            href={row.details.startsWith("http") ? row.details : `https://${row.details}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="click-link"
                          >
                            Click here
                          </a>
                        ) : (
                          <span>{row.details}</span>
                        )
                      ) : (
                        "NA"
                      )}
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section id="infrastructure-information" style={{ padding: '80px 20px', background: 'rgb(100, 19, 32)', color: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* E) SCHOOL INFRASTRUCTURE INFORMATION */}
          <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}> SCHOOL INFRASTRUCTURE INFORMATION</h2>
          <div className="table-responsive">
            <table style={tableStyle}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={thStyle}>SL NO.</th>
                  <th style={thStyle}>INFORMATION</th>
                  <th style={thStyle}>DETAILS</th>
                </tr>
              </thead>
              <tbody>
                {sections.infrastructure_information.map((row, index) => (
                  <tr key={index + 1}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={tdStyle}>{row.information}</td>
                    <td style={tdStyle}>
                      {row.details && row.details !== "#" && row.details !== "" ? (
                        isValidUrl(row.details) ? (
                          <a
                            href={row.details}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="click-link"
                          >
                            Click here
                          </a>
                        ) : (
                          <span>{row.details}</span>
                        )
                      ) : (
                        "NA"
                      )}
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div >
      </section >
    </>
  );
};

export default MandatoryDisclosure;
